import { Injectable } from "@angular/core";
import { saveAs } from "file-saver";

@Injectable({
	providedIn: "root",
})
export class FileSaverService {
	constructor() {}

	public downloadBlobFromUrl(blob_url: string, blobs_name: string): void {
		if (blob_url && blobs_name) {
			saveAs(blob_url, blobs_name);
		}
	}
}
